var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWarning(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 18,
    viewBox: "0 0 20 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.29639 2.97852C9.07151 1.67417 10.9597 1.6742 11.7349 2.97852L17.7485 13.0967C18.5408 14.4299 17.5796 16.1191 16.0288 16.1191H4.00244C2.45182 16.1189 1.49149 14.4298 2.28369 13.0967L8.29639 2.97852ZM10.0571 11.2051C9.16692 11.2051 8.445 11.9057 8.44482 12.7705C8.44486 13.6354 9.16684 14.3369 10.0571 14.3369C10.9471 14.3365 11.6684 13.6352 11.6685 12.7705C11.6683 11.9059 10.947 11.2054 10.0571 11.2051ZM10.0571 5.15723C9.38951 5.15734 8.84818 5.69857 8.84814 6.36621V9.21289C8.8482 9.8805 9.38953 10.4218 10.0571 10.4219C10.7246 10.4216 11.2661 9.88042 11.2661 9.21289V6.36621C11.2661 5.69865 10.7246 5.15747 10.0571 5.15723Z",
    fill: "#2B303B",
    fillOpacity: 0.4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.1d1c1bb7db4c56a2b4e32e8d1f6694fa.svg";
export { ForwardRef as ReactComponent };